import React from 'react';
import {connect} from 'react-redux';

import { history } from '../../../store';

import {
  breaksToBrs,
  formatDiamondTitle, 
} from '../../../utils/formatting';

import * as commonActionCreators from '../../../actions/common';
import * as messagesActionCreators from '../../../actions/messages';
import * as usersActionCreators from '../../../actions/users';
let allActionCreators = Object.assign({}, commonActionCreators, messagesActionCreators, usersActionCreators);

class TransferHistory extends React.Component {


	constructor(props) {
		super(props);

    this.PAGE_SIZE = 50;

    this.state = {
      currentTab: 'open',

      pageNum: 1,

      transfersPending: false,
      transfersResults: null,
      transfersCount: null,
    }

    this.controller = null;
	}

  componentDidMount() {
    this.fetchTransfers();
  }

  async fetchTransfers() {

    const controller = new AbortController();
    this.controller = controller;

    this.setState({
      transfersPending: true,
      transfersResults: null,
      transfersCount: null,
    });

    const searchParams = {
      page: this.state.pageNum,
      status: this.state.currentTab,
    };

    const transfersResp = await this.props.messagesFetchMyTransfers(searchParams, controller.signal)
      .catch((errResp) => {
        if(controller.signal.aborted) { return null; }
        console.error(errResp);
      })

    if(!transfersResp) {
      return null;
    }

    this.setState({
      transfersPending: false,
      transfersResults: transfersResp.transfers,
      transfersCount: parseInt(transfersResp.count) || 0,
    });
  }

  componentWillUnmount() {
    if(this.controller) {
      this.controller.abort();
    }
  }

  userNav(page) {
    history.push('/' + page);
  }

  getTitle() {
    switch(this.state.currentTab) {
      case 'open':
        return 'Open Transfers';
      case 'hold':
        return 'Current Holds';
      default:
        return 'Transfer History';
    }
  }

  selectTab(tabVal) {
    if(this.state.currentTab !== tabVal) {
      this.setState({
        currentTab: tabVal,
      }, () => {
        // load data
        this.fetchTransfers();
      });
    }
  }

  getResults() {
    return this.state.transfersResults;
  }

  getEmptyMessage() {
    switch(this.state.currentTab) {
      case 'open':
        return 'No open transfers';
      case 'hold':
        return 'No current holds';
      default:
        return 'No transfers found';
    }
  }

  getTotalPages() {
    try {
      if(!this.state.transfersCount) { return 1; }
      return Math.ceil(parseInt(this.state.transfersCount) / this.PAGE_SIZE);
    } catch(err) {
      console.error(err);
      return 1;
    }
  }

  decrementPage() {
    const newPage = parseInt(Math.max(parseInt(this.state.pageNum) - 1, 1));
    if(newPage !== this.state.pageNum) {
      this.setState({
        pageNum: newPage,
      }, () => {
        this.fetchTransfers();
      });
    }
  }

  incrementPage() {
    const newPage = parseInt(Math.min(parseInt(this.state.pageNum) + 1, this.getTotalPages()));
    if(newPage !== this.state.pageNum) {
      this.setState({
        pageNum: newPage,
      }, () => {
        this.fetchTransfers();
      });
    }
  }

  getTransferStatus(transfer) {
    // 'Open';
    // 'Waiting for HQ';
    // 'Waiting for Store';
    // 'NA from HQ';
    // 'NA from Store';
    // 'Approved';
    // 'Shipped';
    // 'Cancelled';

    if(transfer.is_cancelled) {
      return 'Cancelled';
    }
    if(transfer.is_shipped) {
      return 'Shipped';
    }
    if(transfer.reject_local_date !== null) {
      return 'NA from Store';
    }
    if(transfer.reject_hq_date !== null) {
      return 'NA from HQ';
    }
    if(transfer.approve_hq_date === null) {
      return 'Waiting for HQ';
    }
    if(transfer.approve_hq_date !== null && transfer.approve_local_date === null) {
      return 'Waiting for Store';
    }
    if(transfer.approve_hq_date !== null && transfer.approve_local_date !== null) {
      return 'Approved';
    }
    return 'Open';
  }

  getHoldStatus(hold) {

    if(hold.approve_date) {
      return 'On Hold'
    }
    return 'Request Pending';
  }

	render() {
		return <div className='TransferHistory'>
      <div className='thWrapper'>
        <div className='titleWrapper'>
          <div className='titleValue'>{this.getTitle()}</div>
        </div>

        <div className='toggleWrapper'>
          <div className='toggleElement'>
            <div className={`toggleButton${this.state.currentTab === 'open' ? ' selected' : ''}`} onClick={() => this.selectTab('open')}>
              <div className='buttonCenter'>Open</div>
            </div>
            <div className={`toggleButton${this.state.currentTab === 'all' ? ' selected' : ''}`} onClick={() => this.selectTab('all')}>
              <div className='buttonCenter'>All</div>
            </div>
            <div className={`toggleButton${this.state.currentTab === 'hold' ? ' selected' : ''}`} onClick={() => this.selectTab('hold')}>
              <div className='buttonCenter'>On Hold</div>
            </div>
          </div>
        </div>

        <div className='resultsWrapper'>
          <div className='resultsHeader'>
            <div className={'headerCell dateCell'}>Date</div>
            <div className={'headerCell statusCell'}>Status</div>
            <div className={'headerCell diamondCell'}>Diamond</div>
            <div className={'headerCell notesCell'}>Notes</div>
          </div>
          {this.getResults() !== null ?
            <div className='resultsBody'>
              {this.getResults().length === 0 ?
                <div className='resultsEmpty'>{this.getEmptyMessage()}</div> :
                <div className='resultsList'>
                  {this.getResults().map((transfer, i) => {
                    return <div className='transferItem' key={i}>
                      <div className='transferItemLiner'>
                        <div className={'dateCell rowCell'}>
                          <div className='cellTitle'>Date</div>
                          <div className='dateElement'>{new Date(transfer.request_date).toLocaleString('en', { dateStyle: 'medium'})}</div>
                          <div className='timeElement'>{new Date(transfer.request_date).toLocaleString('en', { timeStyle: 'medium'})}</div>
                        </div>
                        <div className={'statusCell rowCell'}>
                          <div className='cellTitle'>Status</div>
                          <div className='cellValue'>{this.state.currentTab === 'hold' ? this.getHoldStatus(transfer) : this.getTransferStatus(transfer)}</div>
                        </div>
                        <div className={'diamondCell rowCell'}>
                          <div className='cellTitle'>Diamond</div>
                          <div className='cellValue'>{`${formatDiamondTitle(transfer.diamond)} (${transfer.diamond.web_item})`}</div>
                        </div>
                        <div className={'notesCell rowCell'}>
                          <div className='cellTitle'>Notes</div>
                          <div className='notesRow'>
                            <div className='notesKey'>From:</div>
                            <div className={`notesValue`}>{`${transfer.request_location.short_name} (${transfer.request_location.asc_id})`}</div>
                          </div>
                          <div className='notesRow'>
                            <div className='notesKey'>Request:</div>
                            <div 
                              className={`notesValue${transfer.request_comments || transfer.request_message ? '' : ' nullValue'}`}
                              dangerouslySetInnerHTML={{
                                __html: breaksToBrs(transfer.request_comments || transfer.request_message || 'None', { margin: '0 0 5px 0' }),
                              }} />
                          </div>
                          {this.state.currentTab !== 'hold' ?
                            <div className='notesRow'>
                              <div className='notesKey'>HQ:</div>
                              <div 
                                className={`notesValue${transfer.hq_comments ? '' : ' nullValue'}`}
                                dangerouslySetInnerHTML={{
                                  __html: breaksToBrs(transfer.hq_comments || 'None', { margin: '0 0 5px 0' }),
                                }} />
                            </div> :
                            null
                          }
                          {this.state.currentTab !== 'hold' ?
                            <div className='notesRow'>
                              <div className='notesKey'>Store:</div>
                              <div 
                                className={`notesValue${transfer.local_comments ? '' : ' nullValue'}`}
                                dangerouslySetInnerHTML={{
                                  __html: breaksToBrs(transfer.local_comments || 'None', { margin: '0 0 5px 0' }),
                                }} />
                            </div> :
                            null
                          }
                        </div>
                      </div>
                    </div>;
                  })}
                </div>
              }
            </div> :
            null
          }
          {this.state.currentTab === 'all' && this.state.transfersCount ?
            <div className='resultsPagination'>
              <div className='pageControlsWrapper'>
                <div className={`pageControl${this.state.pageNum <= 1 ? ' inactive' : ''}`} onClick={this.decrementPage.bind(this)}>&lt;</div>
                <div className='pageControlLabel'>{`Page ${this.state.pageNum} of ${this.getTotalPages()}`}</div>
                <div className={`pageControl${this.state.pageNum >= this.getTotalPages() ? ' inactive' : ''}`} onClick={this.incrementPage.bind(this)}>&gt;</div>
              </div>
            </div> :
            null
          }
          {this.state.transfersPending ?
            <div className='resultsLoading'>
              <div className='loadingIcon'>
                <img src='/img/loading.gif' alt='Loading' />
              </div>
            </div> :
            null
          }
        </div>
      </div>
    </div>;
	}
}
export default TransferHistory;

function mapStateToProps(state) {
  return {
    users: state.users,
  };
}

export const TransferHistoryContainer = connect(
  mapStateToProps,
  allActionCreators
)(TransferHistory);